let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jh4hi")).then(() => parcelRequire('am6cJ'));